/**
 * Servicio para gestión de hojas internas (contenido incluido en productos)
 */
import api from "./api";
import { HojaInterna } from "@/components/personalizable/types";

export interface HojasResponse {
  success: boolean;
  hojas: HojaInterna[];
  count: number;
  categoria?: string;
}

export interface CreateHojaResponse {
  success: boolean;
  hoja: HojaInterna;
  message: string;
}

export const hojasService = {
  /**
   * Obtener todas las hojas activas
   */
  async getHojas(): Promise<HojaInterna[]> {
    const response = await api.get<HojasResponse>('/hojas');
    return response.data.hojas;
  },

  /**
   * Obtener hojas por categoría
   */
  async getHojasPorCategoria(categoria: string): Promise<HojaInterna[]> {
    const endpoint = categoria === 'todas'
      ? '/hojas'
      : `/hojas?categoria=${categoria}`;

    const response = await api.get<HojasResponse>(endpoint);
    return response.data.hojas;
  },

  /**
   * Obtener hojas por IDs específicos
   */
  async getHojasPorIds(ids: string[]): Promise<HojaInterna[]> {
    if (!ids || ids.length === 0) {
      return [];
    }

    const todasHojas = await this.getHojas();
    return todasHojas.filter(hoja => ids.includes(hoja.id));
  },

  /**
   * ADMIN: Crear nueva hoja
   */
  async crearHoja(formData: FormData): Promise<HojaInterna> {
    const response = await api.post<CreateHojaResponse>('/hojas', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data.hoja;
  },

  /**
   * ADMIN: Actualizar hoja existente
   */
  async actualizarHoja(id: string, data: Partial<HojaInterna>): Promise<HojaInterna> {
    const response = await api.put<CreateHojaResponse>(`/hojas/${id}`, data);
    return response.data.hoja;
  },

  /**
   * ADMIN: Eliminar hoja
   */
  async eliminarHoja(id: string): Promise<void> {
    await api.delete(`/hojas/${id}`);
  }
};

export default hojasService;
